import { useFleet } from './useFleet';
import { Event } from '../interfaces';

export const useExternalReviewEnabledForFleet = (): boolean => {
  const fleet = useFleet();

  // check if any of the authorities in the fleet has external review enabled
  const authorities = fleet?.authorities || [];
  return authorities.some((authority) => authority.config?.external_review_enabled) || false;
};

export const useExternalReviewIssueWarningEnabledForFleet = (): boolean => {
  const fleet = useFleet();

  const authorities = fleet?.authorities || [];
  return authorities.some(
    (authority) =>
      authority.config?.external_review_enabled &&
      authority.config?.external_review_issue_warning_enabled
  ) || false;
};

export const useExternalReviewIssueWarningEnabledForEvent = (event?: Event): boolean => {
  const fleet = useFleet();

  const eventAuthority = event?.authority_id;
  if (!eventAuthority) {
    return false;
  }

  const authority = fleet?.authorities?.find((a) => a.authority_id === eventAuthority);
  return (
    authority?.config?.external_review_enabled &&
    authority?.config?.external_review_issue_warning_enabled
  ) || false;
};

export const useExternalReviewEnabledForEvent = (event?: Event): boolean => {
  const fleet = useFleet();

  // Events without an authority do not require external review.
  const eventAuthority = event?.authority_id;
  if (!eventAuthority) {
    return false;
  }

  const authority = fleet?.authorities?.find((a) => a.authority_id === eventAuthority);
  return authority?.config?.external_review_enabled || false;
};
